export default class BaseClient {
    baseUrl;
    globalHeaders;
    requestContext;
    urlBuilder;
    uploader;
    options;
    constructor({ baseUrl, headers, urlBuilder, uploader, accessToken, accountId, userRole, onBeforeRequest, ...options }) {
        this.baseUrl = baseUrl;
        this.globalHeaders = headers;
        this.requestContext = { accessToken, accountId, userRole, onBeforeRequest };
        this.urlBuilder = urlBuilder;
        this.uploader = uploader;
        this.options = options;
    }
    setOptions({ baseUrl, headers, urlBuilder, uploader, accessToken, accountId, userRole, onBeforeRequest, ...options }) {
        this.baseUrl = baseUrl;
        this.globalHeaders = headers;
        this.requestContext = { accessToken, accountId, userRole, onBeforeRequest };
        this.urlBuilder = urlBuilder;
        this.uploader = uploader;
        this.options = options;
    }
    getOption(option) {
        return this.options[option];
    }
    buildUrl(path) {
        if (this.urlBuilder) {
            return this.urlBuilder({
                baseUrl: this.baseUrl,
                path,
                accountId: this.requestContext.accountId,
            });
        }
        return this.baseUrl + path;
    }
}
